export default __webpack_public_path__ + "static/media/mb_logo.c2741ccf.svg";